"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActionStatus = void 0;
var ActionStatus;
(function (ActionStatus) {
    ActionStatus["INITIAL"] = "initial";
    ActionStatus["REQUEST"] = "request";
    ActionStatus["SUCCESS"] = "success";
    ActionStatus["FAIL"] = "fail";
})(ActionStatus = exports.ActionStatus || (exports.ActionStatus = {}));
//# sourceMappingURL=types.js.map